import { render } from "./ExternalSystemsAddSprinklr.vue?vue&type=template&id=e20eca80&scoped=true&ts=true"
import script from "./ExternalSystemsAddSprinklr.vue?vue&type=script&lang=ts"
export * from "./ExternalSystemsAddSprinklr.vue?vue&type=script&lang=ts"

import "./ExternalSystemsAddSprinklr.vue?vue&type=style&index=0&id=e20eca80&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20eca80"]])

export default __exports__